import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Users from './Users';
import User from './User';
import Freight from './Freights/Freight/Freight';
import Password from './Password';
import { useLocation } from 'react-router-dom';
import AddOrEditCustomer from './Customers/AddOrEdit/AddOrEdit';
import AddOrEditFreight from './Freights/AddOrEdit/AddOrEdit';
import AddOrEditDriver from './Drivers/AddOrEdit/AddOrEdit';
import AddOrEditOperator from './Operators/AddOrEdit/AddOrEdit';
import Drivers from './Drivers/Drivers';
import Customers from './Customers/Customers';
import Import from './Import/Import';

function UsersIndex(props) {
  const showMessage = (color, position, title, content) => {
    props.showMessage(color, position, title, content);
  };
  const location = useLocation();
  const routes = props.config.childs.map((r, index) => {
    return (
      <Route
        path={`/protected/admin${r.path}`}
        render={(props) => {
          return (
            <r.component {...props} config={r} showMessage={showMessage} />
          );
        }}
        key={index}
      />
    );
  });

  return (
    <>
      {`/protected/admin${props.config.path}` === location.pathname ? (
        <Users showMessage={showMessage} config={props.config} {...props} />
      ) : (
        <Switch>
          {routes}
          <Route path="/protected/admin/users/add/operator">
            <AddOrEditOperator />
          </Route>
          <Route path="/protected/admin/users/add/customer">
            <AddOrEditCustomer />
          </Route>
          <Route path="/protected/admin/users/edit/customer/:id">
            <AddOrEditCustomer />
          </Route>
          <Route path="/protected/admin/users/add/freight">
            <AddOrEditFreight />
          </Route>
          <Route path="/protected/admin/users/edit/freight/:id">
            <AddOrEditFreight />
          </Route>
          <Route path="/protected/admin/users/add/driver">
            <AddOrEditDriver />
          </Route>
          <Route path="/protected/admin/users/edit/driver/:id">
            <AddOrEditDriver />
          </Route>
          <Route exact path="/protected/admin/users/customers">
            <Customers />
          </Route>
          <Route exact path="/protected/admin/users/drivers">
            <Drivers />
          </Route>
          <Route path="/protected/admin/users/import">
            <Import />
          </Route>
          <Route path="/protected/admin/users/:role/:id">
            <User />
          </Route>
          <Route
            path="/protected/admin/users/password/:id"
            children={<Password showMessage={showMessage} />}
          />
        </Switch>
      )}
    </>
  );
}
export default UsersIndex;
